/*
* Contact Map
*/

import {MAP_STYLE} from '../modules/locator'
/* global google */

$.fn.ContactMap = function() {
  let self = this;
  self.map = undefined;

  return function() {
    self.map = new google.maps.Map(self.get(0), {
      styles: MAP_STYLE,
      zoom: 9,
      scrollwheel: false,
      center: {
        lat: 46.095717,
        lng: -75.672833,
      },
    });

    new google.maps.Marker({
      position: {
        lat: 46.095717,
        lng: -75.672833,
      },
      icon: {
        url: '/img/markers/PB_Map_Accueil.svg',
        size: new google.maps.Size(59, 25),
        scaledSize: new google.maps.Size(59, 25),
        origin: new google.maps.Point(0, 0),
      },
      map: self.map,
    })

    return self;
  }();
};
